module.exports = __webpack_public_path__ + "static/media/Partner5.20707dbd.webp";